export interface ModuleOption {
    name: string;
    value: string;
}

export const ModulePropsOption = {
    placeholder: { type: String, default: "" },
    modelValue: { type: Array as PropType<string[]>, required: true },
    disabled: { type: Array as PropType<string[]>, default: [] },
    option: { type: Array as PropType<ModuleOption[]>, required: true },
    width: { type: String },
} as const;

export type ModuleProps = ExtractPropTypes<typeof ModulePropsOption>;
export const ModuleEmits = {
    "update:modelValue": (_r: string[]) => true,
    "change": () => true,
};
